export default __webpack_public_path__ + "static/media/sent.90753895.svg";